import { trackEvent } from '@button/ui/utils';

export const sendReportPageLoadedDebugEvent = async () => {
  await fetch('/debug/report-page-loaded', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const sendLinkCreatedDebugEvent = async (link) => {
  trackEvent('shortlink-created', {
    ...link,
    ...link.tags,
  });
};

export const sendBulkLinkCreatedDebugEvent = async (count, id) => {
  trackEvent('bulk-shortlink-created', {
    count,
    id,
  });
};

export const sendLinkEditedDebugEvent = async (link) => {
  trackEvent('link-edited', {
    ...link,
    ...link.tags,
  });
  await fetch('/debug/link-edited', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      link,
    }),
  });
};

export const sendLinkDetailsPageLoadedDebugEvent = async () => {
  trackEvent('link-details-page-loaded', {
    screen_name: 'Link Details',
  });
  await fetch('/debug/link-details-page-loaded', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const sendMobileAppBannerClickDebugEvent = async () => {
  trackEvent('creator-appstore-link-click');
  await fetch('/api/debug', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      name: 'creator-appstore-link-click',
    }),
  });
};

/**
 * @param {string} name the name of the activity to log
 * @param {Object} data Payload for the additional fields for the table in bigquery
 * @param {string} data.tag the tag on the url if provided
 * @param {Record<any, any>} data.extra the extra params to pass to the log
 */
export const sendDebugEvent = async (name, data) => {
  await fetch('/api/debug', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    keepAlive: true,
    body: JSON.stringify({
      name,
      ...data,
    }),
  });
};

export const sendReportCsvExportDebugEvent = async (reportName) => {
  trackEvent('report-csv-export', {
    report_name: reportName,
    screen_name: 'Reports',
  });
  await fetch('/debug/report-csv-export', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      reportName,
    }),
  });
};
